// Gizli mod — the switch that masks every TL figure on the page while a
// family stands at the desk. It lives in this browser (localStorage)
// and never reaches the door: the figures still arrive, the screen
// just does not print them. The context and its hooks are apart from
// the provider so the component file exports components only.

import {createContext, useContext} from "react";
import {maskNum, maskTL, trNumber, trTL} from "../labels";

export const BLIND_KEY = "nefes.blind";

export interface BlindApi {
  blind: boolean;
  toggle: () => void;
}

export const BlindCtx = createContext<BlindApi>({blind: false, toggle: () => undefined});

export function useBlindSwitch(): BlindApi {
  return useContext(BlindCtx);
}

export function useBlind(): boolean {
  return useContext(BlindCtx).blind;
}

// Money as text, under the switch: the figure, or its mask (one * per
// digit of the whole lira).
export interface MoneyText {
  blind: boolean;
  tl: (n: number) => string; // "4.000 TL" — "**** TL"
  num: (n: number) => string; // "4.000" — "****"
  fee: (feeTL: number | null) => string; // the pair's fee, or that there is none
  text: (s: string) => string; // a sentence from the door, its TL amounts masked
}

export function moneyText(blind: boolean): MoneyText {
  const num = (n: number) => blind ? maskNum(n) : trNumber(n);
  return {
    blind,
    tl: (n) => blind ? `${maskNum(n)} TL` : trTL(n),
    num,
    fee: (feeTL) => feeTL === null ? "ücret tanımsız" : `${num(feeTL)} TL`,
    text: (s) => blind ? maskTL(s) : s,
  };
}

export function useMoney(): MoneyText {
  return moneyText(useBlind());
}
